import { FC, ReactNode } from 'react';

import { CompactCollapsible } from '@/shared';

import { oauthApplicationCreationStepsByKey, OAuthApplicationFormSectionKey } from '../../steps';

export type { OAuthApplicationFormSectionKey } from '../../steps';

interface OAuthApplicationFormSectionProps {
    children: ReactNode;
    description: ReactNode;
    enabled?: boolean;
    open: boolean;
    sectionKey: OAuthApplicationFormSectionKey;
    onToggle: (section: OAuthApplicationFormSectionKey) => void;
}

const OAuthApplicationFormSection: FC<OAuthApplicationFormSectionProps> = ({
    children,
    description,
    enabled = true,
    open,
    sectionKey,
    onToggle,
}) => {
    const section = oauthApplicationCreationStepsByKey[sectionKey];
    const SectionIcon = section.icon;

    return (
        <CompactCollapsible
            description={description}
            disabled={!enabled}
            icon={<SectionIcon />}
            id={section.id}
            label={section.label}
            open={open}
            onOpenChange={() => onToggle(sectionKey)}
        >
            {children}
        </CompactCollapsible>
    );
};

export default OAuthApplicationFormSection;
